/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "%future added value";
export type PostCommentFormContainer_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly site: {
        readonly id: string;
    };
    readonly settings: {
        readonly messageBox: {
            readonly enabled: boolean;
        };
        readonly mode: STORY_MODE;
    };
    readonly " $fragmentRefs": FragmentRefs<"MessageBoxContainer_story">;
    readonly " $refType": "PostCommentFormContainer_story";
};
export type PostCommentFormContainer_story$data = PostCommentFormContainer_story;
export type PostCommentFormContainer_story$key = {
    readonly " $data"?: PostCommentFormContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"PostCommentFormContainer_story">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "PostCommentFormContainer_story",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isClosed",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Site",
                "kind": "LinkedField",
                "name": "site",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "StorySettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoryMessageBox",
                        "kind": "LinkedField",
                        "name": "messageBox",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enabled",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mode",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MessageBoxContainer_story"
            }
        ],
        "type": "Story",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'dd93a98f9b89e62eb6c1e2e4e42ddb8b';
export default node;
